"use client";

import { useEffect } from "react";
import { addRecentTool } from "./local-tool-storage";

type RecentToolTrackerProps = {
  toolId: string;
};

export function RecentToolTracker({ toolId }: RecentToolTrackerProps) {
  useEffect(() => {
    addRecentTool(toolId);
  }, [toolId]);

  return null;
}
